<template>
  <div v-if="isPermission">
    <div v-if="isOrderBuffetEnabled">
      <CCard class="shadow-sm">
        <CCardBody>
          <CRow>
            <CCol sm="1" col="2" lg="1">
              <img src="/img/icon/store.png" style="width: 32px; height:32px;" />
            </CCol>
            <CCol xl="9" lg="8" sm="8" col="7">
              <select class="custom-select text-dark" v-model="shopObjectId" disabled>
                <option selected>{{ $t('selectshop') }}</option>
                <option v-for="shop in shops" :key="shop.objectId" :value="shop.objectId">
                  {{ shop.shopName }} - {{ shop.branchName }}
                </option>
              </select>

            </CCol>
            <div class="col-xl-2 col-lg-3 col-md-3 col-sm-2 col-3 text-right" v-if="loadingButton == true">
              <CButton block color="light" @click="goback()">
                <span><i class="fi fi-rr-arrow-left mr-2" style="position: relative; top: 2px;"></i></span>{{$t('back')}}
              </CButton>
            </div>
            <div class="col-xl-2 col-lg-3 col-md-3 col-sm-2 col-3 text-right" v-else>
              <CButton block color="success" disabled>
                <CSpinner color="white" size="sm" />{{ $t('loading') }}
              </CButton>
            </div>
          </CRow>
        </CCardBody>
      </CCard>
      <CCard class="shadow-sm">
        <CCardBody>
          <CRow>
            <CCol class="col-xl-10 col-lg-9 col-md-9 col-sm-9 col-8 ">
              <h4 class="mb-3"> {{ isEditMode ? $t('updatePackage') : $t('addPackage') }}</h4>
            </CCol>
            <CCol class="col-xl-2 col-lg-3 col-md-3 col-sm-3 col-4 text-right">
              <CButton :disabled="!isEditData || loading || !packageName.trim() || !selectedItems.length"
                @click="isEditMode ? updatePackage() : addPackage()"
                :color="isEditMode && isDirty ? 'warning' : 'success'" block>
                <template v-if="loading">
                  <CSpinner color="white" size="sm" class="mr-2" />
                  {{ $t('loading') }}
                </template>
                <template v-else>
                  <CIcon name="cil-save" color="info" style="margin-right: 8px;" />
                  {{ isEditMode ? $t('updatePackage') : $t('addPackage') }}
                </template>
              </CButton>
            </CCol>
          </CRow>
          <CAlert color="info" class="d-inline-block col-12 mt-1 mb-3">
            <div class="d-flex p-1">
              <div class="flex-shrink-0">
                <i class="fi fi-rr-info mr-1 text-info"></i>
              </div>
              <div class="flex-grow-1 ms-3 ml-2">
                <p class="m-0 font-weight-bold">{{ $t('addPackageDes') }}</p>
                <p class="m-0 text-description text-muted">{{ $t('addPackageDes1') }}</p>
              </div>
            </div>
          </CAlert>
          <CRow>
            <CCol col="9">
              <h5 for="packageName" class="h5 mb-0"><b class="text-danger">*</b> {{ $t('packageName') }}
                <span>
                  <span v-if="isReadyToSell" class="badge badge-lightseagreen ml-1 small">{{ $t('readyToSell') }}</span>
                  <span v-else class="badge badge-tomato ml-1 small">{{ $t('notReadyToSell') }}</span>
                </span>
              </h5>
            </CCol>
            <CCol col="3" class="d-flex align-items-center justify-content-end">
              <label class="mb-0 mr-2 text-dark ">{{ enabled ? $t('enable') : $t('disable') }}</label>
              <CSwitch v-model="enabled" :checked.sync="enabled" color="success" :disabled="!isEditData" />
            </CCol>
          </CRow>
          <CRow class="mb-3">
            <CCol sm="12" md="6">
              <div class="mt-2 mb-3">
                <!-- //คำอธิบาย 1 แพ็ตเกต / 1 bill ราคาเด็ก /ผู้ใหญ่ เป็น SKU  -->
                <small class="text-description text-muted">
                  {{ $t('addPackageDes2') }}
                </small>
                <small class="text-muted d-block mb-2">
                  {{ $t('addPackageDes3') }}
                </small>
                <input v-model="packageName" type="text" class="form-control" id="packageName" :readonly="!isEditData"
                  :placeholder="$t('addPackageDes4')" />
              </div>
              <div class="mb-3">
                <h5 for="packageDescription" class="form-label mb-0">{{ $t('packageDes') }}</h5>
                <small class="text-description text-muted">
                  {{ $t('packageDes1') }}
                </small>
                <textarea v-model="packageDescription" class="form-control" id="packageDescription" rows="3"
                  :placeholder="$t('packageDes')" :readonly="!isEditData"></textarea>
              </div>

              <h5 class="mb-0">
                {{ $t('packageImg') }}
              </h5>
              <small class="text-description text-muted">
                {{ $t('packageImgDes') }}
              </small>
              <div class="img-inputbox mt-2 position-relative mb-4" :class="{ 'dragover': isDragging }"
                @click="triggerFileInput" @dragover.prevent="isDragging = true" @dragleave="isDragging = false"
                @drop="handleDropAndReset">
                <div class="w-100 h-100 d-flex justify-content-center align-items-center">
                  <template v-if="remoteImagePath">
                    <img :src="remoteImagePath"
                      style="width: 100%; height: 100%; object-fit: cover; border-radius: 4px;" />
                    <CButton v-if="remoteImagePath" @click.stop="removeImage" color="danger" size="sm"
                      class="position-absolute" style="top: 4px; right: 4px; z-index: 10; line-height: 1;">
                      <i class="fi fi-rr-trash"></i>
                    </CButton>
                  </template>
                  <template v-else>
                    <div class="pt-1 text-center text-muted">
                      <i class="fi fi-rr-plus-small h1 p-0"></i>
                      <div class="small">{{ $t('draImgHere') }}</div>
                    </div>
                  </template>
                  <input ref="input_img" style="visibility: hidden; display: none;" type="file" accept="image/*"
                    @change="handleFileSelect" />
                </div>
              </div>
              <small class="text-description text-muted">
                {{ $t('chooseThemeColorWhenNoImage') }}
              </small>
              <CRow id="colorButtons" class="flex-wrap justify-content-start m-0 mb-4" style="width: 350px;">
                <div v-for="item in colorList" :key="item.value"
                  class="color-picker-col d-flex justify-content-center align-items-center"
                  style="width: 6.66%; max-width: 6.66%; padding: 1px;">
                  <CButton class="color-picker-btn" :class="{ active: indexColor === item.value }"
                    :style="{ backgroundColor: item.color }" @click="isEditData && setindexcolor(item.value)"
                    :disabled="!isEditData">
                    <i v-if="indexColor === item.value" class="fi fi-rr-check selected-icon"></i>
                  </CButton>
                </div>
              </CRow>

              <div class="mb-4">
                <div class="d-flex align-items-center mb-1">
                  <h5 class="mb-0">
                    <b class="text-danger">*</b> {{ $t('packagePrices') }}
                  </h5>

                  <!-- สวิตช์/เช็กบ็อกซ์ VAT -->
                  <div class="ml-auto d-flex align-items-center text-right">
                    <label for="vatTypeToggle" class="mb-0 mr-2 text-dark ">
                      {{ $t('packageVat') }}
                    </label>
                    <CSwitch id="vatTypeToggle" color="warning" class="" :checked="isVatIncluded"
                      :disabled="!isEditData" @update:checked="isVatIncluded = $event" />
                  </div>
                </div>

                <small class="text-description text-muted">
                  {{ $t('packagePricesHelp1') }}
                </small>
                <span class="text-info" style="cursor: help;">
                  <i class="fi fi-rr-info-circle mr-1"></i>
                  <small class="text-description text-muted">{{ $t('morePricingInfo') }}</small>
                </span>

                <!-- แถวราคาต่าง ๆ -->
                <CRow v-for="(price, index) in packagePrices" :key="index" class="mb-2">
                  <!-- label ชื่อ PLU -->
                  <CCol lg="5" col="4">
                    <input
                      :value="index === 0
                        ? (packageName + ' (' + $t('mainPrice') + ')')
                        : getFullPLUName(index, price)"
                      class="form-control bg-light"
                      disabled
                    />
                  </CCol>

                  <!-- ช่องแก้ชื่อ -->
                  <CCol lg="4" col="3">
                    <div v-if="index === 0">
                      <input
                        v-model="packageName"
                        :readonly="!isEditData"
                        :maxlength="30"
                        disabled
                        class="form-control"
                        :placeholder="$t('priceNamePlaceholder')"
                      />
                    </div>

                    <input
                      v-else
                        v-model="price.shortName"
                      :readonly="!isEditData"
                      class="form-control"
                      :placeholder="$t('priceNamePlaceholder')"
                    />
                  </CCol>

                  <!-- ราคา -->
                  <CCol lg="2" col="3">
                    <input
                      v-model.number="price.price"
                      type="number"
                      min="0"
                      class="form-control"
                      :readonly="!isEditData"
                      :class="{ 'is-invalid': price.hasError && !isValidPrice(price.price, index) }"
                      placeholder="ราคา"
                    />
                  </CCol>

                  <!-- ปุ่มลบ -->
                  <CCol lg="1" col="1">
                    <CButton color="danger" size="sm" v-if="index > 0" @click="removePrice(index)" :disabled="!isEditData">
                      <i class="fi fi-rr-trash"></i>
                    </CButton>
                  </CCol>
                </CRow>

                <!-- ปุ่มเพิ่มราคา -->
                <CButton color="info" size="sm" @click="addPrice" :disabled="!isEditData">
                  <i class="fi fi-rr-plus-small"></i> {{ $t('addPackagePrice') }}
                </CButton>
              </div>
            </CCol>

            <!-- Phone mockup preview -->
            <CCol class="d-flex justify-content-center mt-5 p-0" sm="6" md="6">
              <div>
                <div class="container-phone">
                  <div class="phone-mocking text-dark">
                    <div class="d-flex justify-content-between">
                      <span id="qrOrderSidebarToggle" :style="currentTheme" class="toggles"
                        v-c-emit-root-event:toggle-sidebar-mobile>
                        <i class="fi fi-rr-menu-burger"></i>
                      </span>
                      <span style="text-decoration: underline;" class="pt-1 ">{{ $t('tableEx') }}</span>
                      <span :style="currentTheme" class="callStaff ">
                        <i class="fi fi-rr-cowbell"></i>
                      </span>
                    </div>
                    <div>
                      <p class="pl-2 mb-1">{{ $t('foodCategory') }} </p>
                      <div style="width: 100%; overflow-x: scroll;" class="recommend-container">
                        <!-- View All -->
                        <div :class="selectedCategoryTab === 'viewAll' ? 'category-btn-active' : 'category-btn'"
                          :style="selectedCategoryTab === 'viewAll' ? currentTheme : {}"
                          @click="selectedCategoryTab = 'viewAll'">
                          {{ $t('viewAllFood') }}
                        </div>

                        <!-- Loop over categories -->
                        <div v-for="(i, index) in selectedProductsByCategory" :key="'qrOrderCategory' + index"
                          :class="selectedCategoryTab === i.category ? 'category-btn-active' : 'category-btn'"
                          :style="selectedCategoryTab === i.category ? currentTheme : {}"
                          @click="selectedCategoryTab = i.category">
                          {{ i.category }}
                        </div>

                        <!-- Extra -->
                        <div :class="selectedCategoryTab === 'extra' ? 'category-btn-active' : 'category-btn'"
                          :style="selectedCategoryTab === 'extra' ? currentTheme : {}"
                          @click="selectedCategoryTab = 'extra'">
                          {{ $t('payExtra') }}
                        </div>
                      </div>
                      <input id="qrOrderSearchByNameInput" class="mt-2 form-control" block
                        :placeholder="$t('searchByName')"
                        style="background-color: #eeeeee;font-size:x-small;border: none;" />
                    </div>
                    <div class="mb-5 mt-3">
                      <template v-if="selectedCategoryTab === 'viewAll'">
                        <div v-for="(group, index) in sortedCategories" :key="'viewAllGroup-' + index"
                          class="p-1 mt-1 row">
                          <div class="col-12 font-weight-bold text-muted pb-1">{{ group.category }}</div>
                          <div v-for="(product, idx) in group.products" :key="'product-' + idx" class="col-12 row p-1">
                            <div class="col-3 p-1">
                              <div class="d-flex justify-content-center align-items-center pt-2"
                                :style="getProductImageStyle(product.productSKU)">
                              </div>
                            </div>
                            <div class="col-9 pt-1">
                              {{ product.productSKU.SKUName || product.productSKU.name }}<br />
                              <small class="text-description text-muted truncate-2-lines">{{product.productSKU.description }}</small>
                            </div>
                          </div>
                        </div>
                      </template>

                      <template v-else-if="selectedCategoryTab !== 'extra'">
                        <div v-for="group in selectedProductsByCategory" v-if="group.category === selectedCategoryTab"
                          :key="'categoryGroup-' + group.category" class="p-1 mt-1 row">
                          <div v-for="(product, idx) in group.products" :key="'product-' + idx" class="col-12 row p-1">
                            <div class="col-3 p-1">
                              <div class="d-flex justify-content-center align-items-center pt-2"
                                :style="getProductImageStyle(product)">
                              </div>
                            </div>
                            <div class="col-9 pt-1">
                              {{ product.productSKU.SKUName || product.productSKU.name }}<br />
                              <small
                                class="text-description text-muted truncate-2-lines">{{ product.productSKU.description }}</small>
                            </div>
                          </div>
                        </div>
                      </template>

                      <template v-else>
                        <div v-for="(product, index) in flattenedAdditionalProducts" :key="'extra-' + index"
                          class="row p-1">
                          <div class="col-3 p-1">
                            <div class="d-flex justify-content-center align-items-center pt-2"
                              :style="getProductImageStyle(product)">
                            </div>
                          </div>
                          <div class="col-9 pt-1">
                            {{ product.productSKU.SKUName || product.productSKU.name }}<br />
                            <small class="text-description text-muted truncate-2-lines">{{ product.productSKU.description}}</small>
                            <small class="text-description">
                              ฿{{ getProductPrice(product) }}
                            </small>
                          </div>
                        </div>
                      </template>
                    </div>
                    <div :style="currentTheme" class="footer-home">
                      <div class="d-flex justify-content-between pl-2 pr-2">
                        <span>{{ $t('basket') }} 4 {{ $t('item') }}</span>
                        <span>666 THB</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </CCol>
          </CRow>

          <!-- Products in package -->
          <div>
            <CRow class="mb-2">
              <CCol class="text-left col-md-10 col-sm-9 col-8">
                <h5 class="mb-0"><b class="text-danger">*</b> {{ $t('productInPackage') }}
                  <span class="text-muted" v-if="selectedItems.length > 0">({{ productInPackTotal }}
                    {{ $t('items') }} {{ categoryTotal }} {{ $t('category') }})</span>
                </h5>
                <small class="text-description text-muted">
                  {{ $t('selectProductToAddPackageDes') }}
                </small>
              </CCol>
              <CCol class="text-right" sm="3" md="2" col="4">
                <CButton color="primary" block @click="openAddProductModal(false)" :disabled="!isEditData">
                  <i class="fi fi-rr-plus" style="margin-right: 8px;"></i> {{ $t('addProduct') }}
                </CButton>
              </CCol>
            </CRow>
            <div
              style="max-height: 60vh; overflow-y: auto;border-radius: 5px; border: 2px dashed #cfcfcf; min-height: 50vh; "
              class="p-4">
              <div v-if="selectedProductsByCategory.length === 0"
                class="d-flex flex-column justify-content-center align-items-center text-center"
                style="min-height: 46vh;" @click="addProductModal = true">
                <i class="fi fi-rr-box-open mb-1" style="font-size: 3rem; color: #ccc;"></i>
                <p class="mb-1 font-weight-bold"> {{ $t('packagehavenotproduct') }}</p>
                <small class="text-muted"> {{ $t('click') }} <strong>{{ $t('addProduct') }}</strong>
                  {{ $t('cilckToSelect') }}</small>
              </div>

              <VueDraggable v-else v-model="selectedProductsByCategory" :item-key="'id'">
                <div v-for="group in selectedProductsByCategory" :key="group.id">
                  <div
                    class="d-flex justify-content-between align-items-center bg-light p-2 fw-bold border-bottom rounded drag-handle"
                    style="cursor: grab;">
                    <strong><span class="mr-2">
                        <CIcon name="cil-menu"
                          v-c-tooltip="{ content: $t('dragToChangeOrder'), placement: 'buttom' }" />
                      </span> {{ group.category }} ({{ group.products.length || 0 }} {{ $t('items') }}) </strong>
                    <span>
                      <CButton color="danger" size="sm" @click.stop="removeCategory(group.category)"
                        :disabled="!isEditData" style="line-height: 1;    padding: 0.1rem 0.1rem">
                        <CIcon name="cil-x" />
                      </CButton>
                    </span>
                  </div>
                  <VueDraggable v-model="group.products" :item-key="'id'" :options="{ handle: '.drag-handle' }"
                    @end="updateCategoryOrder" class="row pt-0 pr-1 pl-1">
                    <div v-for="product in group.products" :key="product.id" @end="() => updateProductOrder(group)"
                      class="drag-handle col-12 col-md-4 ml-0 mr-0 p-1" style="padding: 5px;  margin: 2px">
                      <div class="list-group-item d-flex align-items-center border rounded p-2 product-handle"
                        :class="{ 'is-off': product.isEnabled === false }">
                        <div class="me-3 mr-3" style="width: 50px; aspect-ratio: 4 / 3;">
                          <img v-if="product.productSKU.remoteImagePath" :src="product.productSKU.remoteImagePath"
                            style="width: 100%; height: 100%; object-fit: cover; border-radius: 4px" />
                          <div v-else style="width: 100%; height: 100%; border-radius: 4px"
                            :style="{ backgroundColor: util.generateColor(product.productSKU.indexColor) }"></div>
                        </div>
                        <div>
                          <div class="fw-bold product-handle" style="cursor: grab;">
                            {{ product.productSKU.SKUName || product.productSKU.name }}
                          </div>
                          <div class="text-muted small">
                            {{ $t('pricePackage') }}: {{ product.productSKU.SKUPrice || 0.00 }}
                          </div>
                        </div>
                        <div class="action-right">
                          <CSwitch :checked="product.isEnabled !== false"
                            @update:checked="onToggleItemEnabled(product, $event)" :disabled="!isEditData"
                            @change="onToggleItemEnabled(product, $event)" color="success"
                            v-c-tooltip="{ content: 'เปิด/ปิดการขาย', placement: 'top' }" />
                          <CButton color="light" size="sm"
                            @click.stop.prevent="removeProductFromGroupSafe(group.category, product)" @mousedown.stop
                            @touchstart.stop class="close-btn" :disabled="!isEditData">
                            <CIcon name="cil-x" />
                          </CButton>
                        </div>
                      </div>
                    </div>
                  </VueDraggable>
                </div>
              </VueDraggable>
            </div>
          </div>

          <!-- Extra products -->
          <CRow class="mb-2 mt-4">
            <CCol class="text-left col-md-9 col-sm-9 col-8">
              <h5 class="mb-0"><b class="text-danger">*</b> {{ $t('extraProducts') }}
                <span class="text-muted" v-if="additionalItems.length > 0">({{ additionalItems.length }}
                  {{ $t('items') }})</span>
              </h5>
              <small class="text-description text-muted">{{ $t('selectExtraProducts') }}</small>
            </CCol>
            <CCol class="text-right" sm="4" md="3" col="4">
              <CButton color="primary" block @click="openAddProductModal(true)" :disabled="!isEditData">
                <i class="fi fi-rr-plus" style="margin-right: 8px;"></i> {{ $t('addProductExtra') }}
              </CButton>
            </CCol>
          </CRow>

          <div
            style="max-height: 60vh; overflow-y: auto; border-radius: 5px; border: 2px dashed #cfcfcf; min-height: 30vh;"
            class="p-4">
            <div v-if="flattenedAdditionalProducts.length === 0"
              class="d-flex flex-column justify-content-center align-items-center text-center" style="min-height: 26vh;"
              @click="addExtraProductModal = true">
              <i class="fi fi-rr-box-open mb-1" style="font-size: 3rem; color: #ccc;"></i>
              <p class="mb-1 font-weight-bold">{{ $t('extraProductEmpty') }}</p>
              <small class="text-muted">
                {{ $t('click') }} <strong>{{ $t('addProduct') }}</strong> {{ $t('cilckToSelect') }}
              </small>
            </div>

            <VueDraggable v-model="additionalItems" :item-key="'objectId'"
              :options="{ animation: 150, handle: '.product-handle' }" class="row pt-0 pr-1 pl-1"
              @end="updateExtraProductOrder">
              <div v-for="product in additionalItems" :key="product.objectId" class="col-12 col-md-4 p-1">
                <div class="list-group-item d-flex align-items-center border rounded p-2 product-handle"
                  :class="{ 'is-off': product.isEnabled === false }">
                  <div class="me-3 mr-3" style="width: 50px; aspect-ratio: 4 / 3;">
                    <img v-if="product.productSKU.remoteImagePath" :src="product.productSKU.remoteImagePath"
                      style="width: 100%; height: 100%; object-fit: cover; border-radius: 4px" />
                    <div v-else style="width: 100%; height: 100%; border-radius: 4px"
                      :style="{ backgroundColor: util.generateColor(product.productSKU.indexColor) }"></div>
                  </div>
                  <div>
                    <div class="fw-bold " style="cursor: grab;">
                    
                       {{ product.productSKU.SKUName || product.productSKU.name }}
                    </div>
                    <div class="text-muted small">
                      {{ $t('pricePackage') }}: {{ product.productSKU.SKUPrice || 0.00 }}
                    </div>
                  </div>
                  <div class="action-right">
                    <CSwitch :checked="product.isEnabled !== false"
                      @update:checked="onToggleItemEnabled(product, $event)" :disabled="!isEditData"
                      @change="onToggleItemEnabled(product, $event)" color="success"
                      v-c-tooltip="{ content: 'เปิด/ปิดการขาย', placement: 'top' }" />
                    <CButton color="light" size="sm" @click.stop.prevent="onRemoveExtra(product)" @mousedown.stop
                      :disabled="!isEditData" @touchstart.stop class="close-btn">
                      <CIcon name="cil-x" />
                    </CButton>
                  </div>
                </div>
              </div>
            </VueDraggable>
          </div>
        </CCardBody>
      </CCard>

      <!-- modal เลือกสินค้า -->
      <modal :show.sync="addProductModal" size="xl" :footer="false">
        <template>
          <div>
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h5>{{ $t('selectdProduct') }}</h5>
            </div>
            <CRow>
              <CCol lg="3" col="5">
                <multiselect v-model="searchCategory" :options="dataCategory" :search="true" :showLabels="false"
                  :close-on-select="true" :clear-on-select="false" :placeholder="$t('selectCategoryInput')" label="name"
                  track-by="name" @input="setSearch" class="text-dark font-weight-normal  align-items-center" style=" 
                    -webkit-box-align: center !important;
                    -ms-flex-align: center !important;
                    align-items: center !important;">
                </multiselect>
              </CCol>
              <CCol lg="7" col="5">
                <input v-model="searchTerm" class="form-control" type="text" placeholder="Search product" />
              </CCol>
              <CCol lg="2" col="2">
                <CButton color="primary" block>
                  {{ $t('search') }}
                </CButton>
              </CCol>
            </CRow>

            <CRow class="mb-1 mt-3">
              <CCol>
                <div class="text-left ">
                  <div class="custom-checkbox-wrapper">
                    <input type="checkbox" id="selectAllGlobal" :checked="areAllSelected" @change="toggleSelectAll"
                      class="custom-checkbox-input" />
                    <label for="selectAllGlobal" class="ml-2 mb-0">{{ $t('selectAllProduct') }}</label>
                  </div>
                </div>
              </CCol>
              <CCol class="text-right">
                <span class="text-muted" v-if="selectedItems.length > 0">{{ $t('select') }} {{ productTotal }}
                  {{ $t('items') }} {{ categoryTotal }} {{ $t('category') }}</span>
              </CCol>
            </CRow>

            <div style="max-height: 60vh; overflow-y: auto; ">
              <div v-for="(products, category) in filteredCategorizedProducts" :key="category" class="mb-2"
                style="border: 1px solid #ddd; border-radius: 8px;">
                <div class="d-flex justify-content-between align-items-center bg-light p-2 fw-bold border-bottom"
                  style="position: sticky; top: 0; background-color: #f8f9fa; z-index: 1;">
                  <span>
                    <div class="custom-checkbox-wrapper d-flex align-items-center">
                      <input type="checkbox" :id="'selectAll-' + category" :checked="areAllSelectedByCategory(category)"
                        @change="toggleSelectAllByCategory(category)" class="custom-checkbox-input" />
                      <label :for="'selectAll-' + category" class="mb-0 ms-2">
                        {{ $t('categoryHeaderWithCount', { name: category, count: products.length }) }}
                      </label>
                    </div>
                  </span>
                </div>

                <div v-for="(product, index) in products" :key="product.objectId" :class="[
                  'd-flex align-items-center justify-content-between p-2 pb-0',
                  { 'border-bottom': index !== products.length - 1 }
                ]"
                  :style="{ cursor: isProductDisabled(product) ? 'not-allowed' : 'pointer', opacity: isProductDisabled(product) ? 0.5 : 1 }">
                  <div class="d-flex align-items-center" @click="!isProductDisabled(product) && toggleItem(product)">
                    <input type="checkbox" :id="'checkbox-' + product.objectId"
                      :checked="selectedItems.some(p => p.productSKU.objectId === product.objectId)" @click.stop
                      :disabled="isProductDisabled(product)"
                      @change="!isProductDisabled(product) && toggleItem(product)"
                      class="custom-checkbox-input me-2 mr-3" />
                    <label :for="'checkbox-' + product.objectId" class="d-flex align-items-center mb-0" @click.stop>
                      <div class="me-2 mr-3" style="width: 50px; height: auto; aspect-ratio: 4 / 3;">
                        <img v-if="product.remoteImagePath" :src="product.remoteImagePath" alt="product"
                          style="width: 100%; height: 100%; object-fit: cover; border-radius: 4px" />
                        <div v-else style="width: 100%; height: 100%; border-radius: 4px"
                          :style="{ backgroundColor: util.generateColor(product.indexColor) }"></div>
                      </div>
                      <div>
                        <div>{{ product.SKUName }}</div>
                        <div v-if="productDisabledMessage(product)" class="text-danger small">
                          {{ productDisabledMessage(product) }}
                        </div>
                      </div>
                    </label>
                  </div>

                  <div class="text-end text-muted small">
                  </div>
                </div>

              </div>
            </div>
            <pagination :meta_data="meta_data" v-on:next="getProduct">
            </pagination>
          </div>
        </template>
      </modal>

      <!-- modal รูปภาพ -->
      <CRow>
        <CModal :closeOnBackdrop="false" color="success" :show.sync="selectimg" :title="$t('selectImg')" centered>
          <div class="text-center" v-if="loadingSaveimg">
            <div class="row">
              <div :class="imageDataBtn.length > 0 ? 'col-md-9 col-6 text-left' : 'col-md-12 col-12 text-left'">
                <div class="file-upload-container  pr-4 pl-5 pt-0 mb-1">
                  <label class="custom-file-label ml-2">
                    <input type="file" ref="fileInput" accept="image/*" @click="triggerFileInput" />
                    <i class="fa fa-upload"></i> {{ $t('selectImgFromPC') }}
                  </label>
                </div>
              </div>
              <div v-if="imageDataBtn.length > 0" class="col-md-3 col-6 text-right" id="deleteImageSection">
                <CButton style="color: red" @click="removeImage" id="deleteImageButton">
                  <i class="fi fi-rr-trash"></i> {{ $t("deleteImg") }}
                </CButton>
              </div>
              <div v-if="imageDataBtn.length > 0" class="col-md-12 text-center  mt-2">
                <div class="drop-area" :class="{ dragover: isDragging }" @dragover.prevent="isDragging = true"
                  @dragleave="isDragging = false" @drop="handleDropInModal">
                  <VueCropper v-if="!isUpload && !imageDataBtn.startsWith('https://firebasestorage')" :key="cropperKey"
                    v-show="imageDataBtn" :guides="true" :aspectRatio="selectedRatio"
                    :initialAspectRatio="selectedRatio" ref="cropper" :src="imageDataBtn" alt="Source Image"
                    :zoomable="false" :scalable="false" :style="{ height: cropperHeight + 'px' }">
                  </VueCropper>
                  <img v-else :src="imageDataBtn" class="img-fluid" :style="{ height: cropperHeight + 'px' }" />
                </div>
              </div>
              <div class="text-center p-3" v-if="!isUpload && !imageDataBtn.startsWith('https://firebasestorage')">
                <div class="row align-items-center d-flex">
                  <div class="col-auto flex-grow-1 d-flex justify-content-center" v-for="(ratio, index) in cropRatios"
                    :key="index" style="padding-left: 1px; padding-right: 1px;">
                    <CButton color="dark" class="ratio-btn w-100 text-center"
                      :class="{ active: selectedRatio === ratio.value }" @click="setCropRatio(ratio.value)">
                      <p class="mb-0 ml-1 mr-1">{{ ratio.label }}</p>
                    </CButton>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="text-center" width="100%">
              <button class="btn" type="button" disabled style="color: darkcyan">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                {{ $t('imageUploading') }}...
              </button>
            </div>
          </div>
          <template #footer-wrapper>
            <CRow class="pl-4 pr-4 pb-4">
              <CCol>
                <CButton block color="light" @click="cancel">
                  {{ $t('cancel') }}
                </CButton>
              </CCol>
              <CCol>
                <CButton block color="success" v-if="loadingSaveimg" @click="savecolorimg">
                  {{ $t('save') }}
                </CButton>
                <CButton block color="success" v-else disabled>
                  {{ $t('save') }}
                </CButton>
              </CCol>
            </CRow>
          </template>
        </CModal>
      </CRow>
    </div>
    <div v-else>
      <CCard>
        <CCardBody>
          <img src="/img/BF-banner.jpg" alt="Feature Not Available" style="    width: -webkit-fill-available; " />
        </CCardBody>
      </CCard>
    </div>
  </div>
  <div v-else>
    <access-data></access-data>
  </div>
</template>

<script>
import pos from "@/services/local";
import packageservice from "@/services/package";
import util from "@/util/util";
import Multiselect from "vue-multiselect";
import { mapGetters } from 'vuex'
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'
import mime from '@/util/mime'
import { VueDraggable } from 'vue-draggable-plus'
import permis from '@/util/permission'
import Pagination from '@/containers/Pagination'

export default {
  name: 'AddProductPackage',
  data() {
    return {
      packageData : {},
      util,
      searchTerm: '',
      packageName: '',
      packageDescription: '',
      selectedItems: [],
      loading: false,
      products: [],
      keyword: this.$route.query.keyword || "",
      searchBy: this.$route.query.searchBy || "",
      sort_value: {
        name: "SKUName",
        updated_at: "updated_at",
        category: "category.name",
        sortByNumMin: "sortByNumMin",
        sortByNumMax: "sortByNumMax",
      },
      sortdata: this.$route.query.sort || "category.name",
      meta_data: {
        last_page: null,
        current_page: 1,
        prev_page_url: null,
        items: 0,
        limit: 100,
        itemCount: 0,
      },
      addProductModal: false,
      dataCategory: [],
      searchCategory: "",
      shop: this.$store.getters.shopObjectId,
      selectimg: false,
      imageDataBtn: '',
      isUpload: false,
      cropperKey: 0,
      selectedRatio: 1,
      loadingSaveimg: true,
      isload: false,
      genObjectId: '',
      remoteImagePath: '',
      indexColor: 1,
      colori: util.generateColor(1),
      isDragging: false,
      isEditMode: false,
      ProductSKUPackage: [],
      vatType: 'N',
      originalVatType: 'N',
      // packagePrices เก็บ shortName เท่านั้น
      packagePrices: [
        { shortName: '', price: 0, hasError: false, PLUCode: util.generateBarcode() }
      ],
      originalPackageName: '',
      originalPackageDescription: '',
      originalPackagePrices: [],
      originalSelectedItems: [],
      originalImagePath: '',
      originalIndexColor: 1,
      originalEnabled: true,
      enabled: true,
      additionalItems: [],
      isAddingExtraProduct: false,
      selectedCategoryTab: 'viewAll',
      selectedProductsByCategory: [],
      isOrderBuffetEnabled: false,
    };
  },
  async created() {
    this.getOrderShopSetting()
    this.initializePage();
  },
  computed: {
    ...mapGetters(['shops', 'users', 'date', 'shopsetting']),
    isVatIncluded: {
      get() { return this.vatType === 'V'; },
      set(v) { this.vatType = v ? 'V' : 'N'; },
    },
    isPermission() {
      return permis.findPermissionRead("product", '/product/package')
    },
    isEditData() {
      return permis.findPermissionEdit("product", '/product/package')
    },
    isDeleteData() {
      return permis.findPermissionRemove("product", '/product/package')
    },
    isReadyToSell() {
      return this.packagePrices[0]?.price > 0 && this.selectedItems.length > 0;
    },
    productInPackTotal() {
      return this.selectedItems.filter(item => item.inSET === true).length;
    },
    isDirty() {
      const simplifyPrices = (arr = []) =>
        arr.map((p, i) => ({
          // แถว 0 ไม่ต้องเทียบชื่อย่อย
          shortName: i === 0 ? null : (p.shortName || '').trim(),
          price: Number(p.price) || 0,
        }));

      const norm = (items = []) =>
        items
          .map(it => ({
            skuId: it.productSKU?.objectId || it.productSKUObjectId || it.objectId,
            inSET: !!it.inSET,
            isEnabled: it.isEnabled !== false,
          }))
          .sort((a, b) =>
            (a.skuId || '').localeCompare(b.skuId || '') || Number(b.inSET) - Number(a.inSET)
          );

      const cur = norm(this.selectedItems);
      const orig = norm(this.originalSelectedItems);

      return (
        this.packageName !== this.originalPackageName ||
        this.packageDescription !== this.originalPackageDescription ||
        JSON.stringify(simplifyPrices(this.packagePrices)) !== JSON.stringify(simplifyPrices(this.originalPackagePrices)) ||
        JSON.stringify(cur) !== JSON.stringify(orig) ||
        this.indexColor !== this.originalIndexColor ||
        this.remoteImagePath !== this.originalImagePath ||
        this.enabled !== this.originalEnabled ||
        this.vatType !== this.originalVatType
      );
    },
    dragDelay() {
      return this.isTouchDevice ? 400 : 0;
    },
    isTouchDevice() {
      return (
        'ontouchstart' in window ||
        navigator.maxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0
      );
    },
    cropperHeight() {
      if (window.innerWidth < 480) return 200;
      if (window.innerWidth < 768) return 250;
      return 300;
    },
    colorList() {
      let data = [];
      for (let i = 0; i < 30; i++) {
        data.push({
          color: util.generateColor(i),
          value: i,
        });
      }
      return data;
    },
    cropRatios() {
      return [
        { label: "Freeform", value: "freeform" },
        { label: "1:1", value: "1:1" },
        { label: "3:2", value: "3:2" },
        { label: "4:3", value: "4:3" },
        { label: "16:9", value: "16:9" },
        { label: "Original Ratio", value: "original" }
      ]
    },
    contentMinH() {
      return `calc(100vh - 400px)`;
    },
    productTotal() {
      return this.selectedItems.length;
    },
    noImage() {
      return process.env.VUE_APP_NOIMAGE
    },
    categoryTotal() {
      return Object.keys(this.selectedProductsByCategory).length;
    },
    selectedItemsDetail() {
      return this.products.filter((p) => this.selectedItems.includes(p.objectId));
    },
    categorizedProducts() {
      const grouped = {};
      const categoryMap = {};
      this.dataCategory.forEach((cat) => {
        categoryMap[cat.objectId] = cat;
      });

      this.products.forEach((product) => {
        const categoryId = product.category?.objectId;
        const category = categoryMap[categoryId] || { name: 'ไม่ระบุหมวด', objectId: 'unknown' };
        const key = category.name;

        if (!grouped[key]) grouped[key] = [];
        grouped[key].push(product);
      });

      return grouped;
    },
    filteredCategorizedProducts() {
      const filtered = {};
      const term = (this.searchTerm || '').toLowerCase();

      Object.entries(this.categorizedProducts).forEach(([cat, products]) => {
        const matches = products.filter((p) =>
          (p.SKUName || '').toLowerCase().includes(term) ||
          (p.objectId || '').toLowerCase().includes(term)
        );
        if (matches.length) filtered[cat] = matches;
      });

      return filtered;
    },
    areAllSelected() {
      const selectedIds = this.selectedItems.map(p => p.productSKU.objectId);
      const allIds = this.products.map(p => p.objectId);
      return allIds.length > 0 && allIds.every(id => selectedIds.includes(id));
    },
    shopObjectId: {
      get() {
        return this.$store.getters.shopObjectId;
      },
      set(newValue) {
        return this.$store.dispatch("setShop", newValue);
      },
    },
    sortedCategories() {
      return this.selectedProductsByCategory
        .slice()
        .sort((a, b) => a.orderIndex - b.orderIndex)
        .map(group => ({
          ...group,
          products: group.products
            .slice()
            .filter(p => p.isEnabled !== false)
            .sort((a, b) => a.orderIndex - b.orderIndex),
        }));
    },
    flattenedAdditionalProducts() {
      return this.selectedItems
        .filter(p => p.inSET === false)
        .map((product, index) => ({
          ...product,
          orderIndex: index
        }));
    },
    productDisabledMessage() {
      return (product) => {
        const selectedProduct = this.selectedItems.find(p => p.objectId === product.objectId);
        if (!selectedProduct) return null;
        if (this.isAddingExtraProduct && selectedProduct.inSET) {
          return this.$t('productInPackage');
        }
        if (!this.isAddingExtraProduct && !selectedProduct.inSET) {
          return this.$t('productInExtraList');
        }
        return null;
      };
    },
    currentTheme() {
      return {
        'background-color': this.colori
      }
    },
    uid() {
      return `${localStorage.getItem('shopsUid')}`
    },
  },
  watch: {
    selectedItems: {
      handler() {
        this.selectedProductsByCategory = this.groupedProductsByInSET(true);
      },
      deep: true
    },
    additionalItems: {
      handler() {
        this.selectedItems = this.onProductReorder();
      },
      deep: true,
      immediate: false
    },
    packageName() {
      // ไม่ต้อง sync อะไรที่ packagePrices แล้ว
    }
  },

  components: {
    Multiselect,
    VueCropper,
    VueDraggable,
    Pagination,
  },
  methods: {
    ...util,
    extractSubName(fullName, packageName) {
      if (!fullName) return '';
      if (!fullName.startsWith(packageName)) return '';

      const start = fullName.indexOf('(');
      const end = fullName.lastIndexOf(')');

      if (start === -1 || end === -1 || end <= start + 1) return '';

      return fullName.substring(start + 1, end).trim();
    },

    getOrderShopSetting() {
      const shopObjectId = `${localStorage.getItem('shopObjectId')}`
      let params = {
        shopObjectId: shopObjectId,
      }
      const headers = {
        shopObjectId: util.sanitizeShopObjectId(shopObjectId),
      }
      pos({
        url: "/api/v3.0/shop/ordershopsetting",
        params: params,
        headers: headers,
        method: "get",
      }).then((res) => {
        if (res.status == 200) {
          let isOrderBuffetEnabled = res.data.data.isOrderBuffetEnabled
          if (isOrderBuffetEnabled !== undefined && isOrderBuffetEnabled !== null && isOrderBuffetEnabled !== '') {
            this.isOrderBuffetEnabled = isOrderBuffetEnabled
          } else {
            this.isOrderBuffetEnabled = false
          }
        } else {
          this.isOrderBuffetEnabled = false
        }

      }).catch((error) => {
        console.log(error);
      });
    },
    normalizeOrderIndices() {
      let idx = 0;

      const groups = this.selectedProductsByCategory
        .slice()
        .sort((a, b) => {
          if (a.name === 'Uncategory') return 1;
          if (b.name === 'Uncategory') return -1;
          return a.orderIndex - b.orderIndex;
        });

      groups.forEach(g => {
        g.products
          .slice()
          .sort((a, b) => a.orderIndex - b.orderIndex)
          .forEach(p => {
            this.$set(p, 'orderIndex', idx++);
          });
      });

      this.additionalItems.forEach(p => {
        this.$set(p, 'orderIndex', idx++);
      });

      this.selectedItems = this.onProductReorder();
    },
    onToggleItemEnabled(item, e) {
      const isOn = typeof e === 'boolean' ? e : !!e?.target?.checked;
      this.$set(item, 'isEnabled', isOn);

      const sku = this.getSKU(item);
      const key = sku?.objectId;
      const idx = this.selectedItems.findIndex(
        it => (it.productSKU?.objectId || it.productSKUObjectId || it.objectId) === key
      );
      if (idx !== -1) this.$set(this.selectedItems[idx], 'isEnabled', isOn);

      const eIdx = this.additionalItems.findIndex(
        it => (it.productSKU?.objectId || it.productSKUObjectId || it.objectId) === key
      );
      if (eIdx !== -1) this.$set(this.additionalItems[eIdx], 'isEnabled', isOn);
    },
    getSKU(obj) {
      return obj?.productSKU ?? obj;
    },
    isProductDisabled(product) {
      const selectedProduct = this.selectedItems.find(p => p.productSKU.objectId === product.objectId);

      if (!selectedProduct) return false;

      if (this.isAddingExtraProduct) {
        return selectedProduct.inSET === true;
      } else {
        return selectedProduct.inSET === false;
      }
    },
    onRemoveExtra(product) {
      const id = product.productSKU?.objectId || product.objectId
      this.removeFlatProduct(id)
    },

    removeFlatProduct(objectId) {
      this.selectedItems = this.selectedItems.filter(
        p => (p.productSKU?.objectId || p.objectId) !== objectId
      )
      this.additionalItems = this.flattenedAdditionalProducts
    },
    async initializePage() {
      await this.getProduct();
      await this.getCategory();
    },
    goback() {
      this.$router.push({ name: 'ProductPackage' });
    },
    openAddProductModal(isExtra) {
      this.isAddingExtraProduct = isExtra;
      this.addProductModal = true;
    },
    minifySKU(sku) {
      return {
        id: sku.objectId,
        objectId: sku.objectId,
        name: sku.SKUName || sku.name || '',
        SKUName: sku.SKUName || sku.name || '',
        remoteImagePath: sku.remoteImagePath || '',
        SKUPrice: Number(sku.SKUPrice || 0),
        indexColor: Number(sku.indexColor ?? 0),
        category: sku.category || null,
      };
    },

    minifySelectedItem(item, inSETFlag) {
      const skuRaw = (this.getSKU && this.getSKU(item)) || item.productSKU || item;
      const sku = this.minifySKU(skuRaw);
      return {
        productSKU: sku,
        productSKUObjectId: sku.objectId,
        inSET: typeof item.inSET === 'boolean' ? item.inSET : (inSETFlag ?? !this.isAddingExtraProduct),
        orderIndex: Number.isFinite(item.orderIndex) ? item.orderIndex : 0,
        maximumStack: Number(item.maximumStack || 0),
        isEnabled: typeof item.isEnabled === 'boolean' ? item.isEnabled : true,
      };
    },
    async loadPackage(packageId) {
      const headers = { shopObjectId: util.sanitizeShopObjectId(this.shopObjectId) }
      let params = {
        objectId: packageId
      }
      try {
        const URL = '/api/v3.0/' + this.uid + '/productpackage'
        const res = await pos.get(URL, { params, headers })

        const pkg = res.data.data
        console.log('pkg',pkg);
        
        this.packageData = pkg
        this.packageName = pkg.name;
        this.packageDescription = pkg.description;
        this.remoteImagePath = pkg.remoteImagePath;
        this.indexColor = pkg.indexColor || 0;
        this.colori = util.generateColor(this.indexColor);
        this.vatType = pkg.vatType || 'N';
        this.originalVatType = this.vatType;
        this.enabled = pkg.enabled !== undefined ? pkg.enabled : true;

        // map productPLU -> packagePrices (ใช้ shortName)
        this.packagePrices = pkg.productPLU?.length
          ? pkg.productPLU.map((p, i) => ({
              id: p.id,
              objectId: p.objectId,
              price: Number(p.price) || 0,
              PLUCode: p.PLUCode || '',
              isProductPLU1 : p.isProductPLU1,
              shortName: i === 0
                ? ''
                : (p.shortName || this.extractSubName(p.name, pkg.name) || ''),
              hasError: false,
            }))
          : [{ shortName: '', price: 0, hasError: false }];
            
        this.selectedItems = [...pkg.ProductSKUPackage]
        this.additionalItems = this.selectedItems.filter(p => p.inSET === false);
        this.selectedProductsByCategory = this.groupedProductsByInSET(true);

        this.originalPackageName = this.packageName;
        this.originalPackageDescription = this.packageDescription;
        this.originalPackagePrices = JSON.parse(JSON.stringify(this.packagePrices));
        this.originalSelectedItems = JSON.parse(JSON.stringify(this.selectedItems));
        this.originalImagePath = this.remoteImagePath;
        this.originalIndexColor = this.indexColor;
        this.originalEnabled = this.enabled;

        this.isEditMode = true;
        this.$nextTick(() => {
          this.selectedItems = [...pkg.ProductSKUPackage];
          this.additionalItems = this.flattenedAdditionalProducts;
          this.selectedProductsByCategory = this.groupedProductsByInSET(true);
        });

      } catch (error) {
        console.log(error)
      }
    },
    // ชื่อเต็มที่ใช้แสดง/ส่งให้ BE: packageName + (shortName)
    getFullPLUName(index, price) {
      const base = (this.packageName || '').trim()
      if (!base) return ''

      if (index === 0) return base

      const short = (price.shortName || '').trim()
      return short ? `${base} (${short})` : base
    },
    // ให้ formatPLUName ดึงจาก helper นี้
    formatPLUName(index, price) {
      return this.getFullPLUName(index, price)
    },
    // handle เวลา user แก้ข้อความใน input PLU แถวรอง
    onPLUNameInput(index, value, price) {
      const base = (this.packageName || '').trim()
      const raw = (value || '').trim()

      if (!base || !raw.startsWith(base)) {
        price.shortName = raw
        return
      }

      let sub = raw.slice(base.length).trim()
      const m = sub.match(/^\((.*)\)$/)
      if (m) sub = m[1]

      price.shortName = sub.trim()
    },
   async generateObjectIdPack() {
      const uid = `${localStorage.getItem("shopsUid")}`;
      try {
        const res = await pos({
          method: "get",
          url: `/api/v1.0/${uid}/objectId/generate`,
        });
        return res.data.data.objectId;
      } catch (error) {
        console.error("Error generating objectId:", error);
        return null; // หรือจัดการ Error ตามต้องการ
      }
    },
    async addPrice() {
      const newObjectId = await this.generateObjectIdPack();
      this.packagePrices.push({
        objectId : newObjectId,
        shortName: '',
        isProductPLU1 : false,
        price: 0,
        PLUCode: util.generateBarcode(),
        hasError: false,
      });
    },
    isValidPrice(price, index) {
      const mainPrice = parseFloat(this.packagePrices[0].price || 0);
      return index === 0 || parseFloat(price || 0) < mainPrice;
    },
    removePrice(index) {
      if (this.packagePrices.length > 1) {
        this.packagePrices.splice(index, 1);
      }
    },
    removeCategory(categoryName) {
      const group = this.selectedProductsByCategory.find(g => g.category === categoryName);
      if (!group) return;

      const skuIdOf = (x) => x?.productSKU?.objectId || x?.productSKUObjectId || x?.objectId;

      const skuIdsInGroup = group.products
        .filter(p => p.inSET === true)
        .map(p => skuIdOf(p))
        .filter(Boolean);

      this.selectedItems = this.selectedItems.filter(it => {
        const id = skuIdOf(it);
        if (it.inSET === false) return true;
        return !skuIdsInGroup.includes(id);
      });

      this.additionalItems = this.flattenedAdditionalProducts;
      this.selectedProductsByCategory = this.groupedProductsByInSET(true);
    },
    removeProductFromGroupSafe(categoryName, product) {
      const productId = product?.productSKU?.objectId || product?.objectId;
      this.removeProductFromGroup(categoryName, productId);
    },

    removeProductFromGroup(categoryName, productId) {
      const group = this.selectedProductsByCategory.find(g => g.category === categoryName);
      if (group) {
        group.products = group.products.filter(p => (p.productSKU?.objectId || p.objectId) !== productId);
        if (group.products.length === 0) {
          this.selectedProductsByCategory = this.selectedProductsByCategory.filter(g => g.category !== categoryName);
        }
      }
      this.selectedItems = this.selectedItems.filter(item => (item.productSKU?.objectId || item.objectId) !== productId);
    },
    updateCategoryOrder() {
      this.selectedProductsByCategory.forEach((group, index) => {
        group.orderIndex = index;
      });
      this.selectedItems = this.onProductReorder();
      this.normalizeOrderIndices();
    },
    groupedProductsByInSET(inSETValue) {
      const grouped = {};
      const categoryMap = {};
      this.dataCategory.forEach(cat => {
        categoryMap[cat.objectId] = cat;
      });

      this.selectedItems
        .filter(product => product.inSET === inSETValue)
        .forEach((product, globalIndex) => {
          const catObj = product?.productSKU?.category || {};
          const objectId = product.productSKU.category?.objectId;
          const category = categoryMap[objectId] || { name: 'ไม่ระบุหมวด', objectId: 'unknown' };
          const key = category.name;

          if (!grouped[key]) {
            grouped[key] = {
              category: key,
              products: [],
              orderIndex: Object.keys(grouped).length
            };
          }
          product.orderIndex = globalIndex;
          grouped[key].products.push({
            ...product,
            isEnabled: product.isEnabled,
            orderIndex: grouped[key].products.length
          });
        });

      return Object.values(grouped);
    },
    updateExtraProductOrder() {
      this.additionalItems.forEach((product, index) => {
        product.orderIndex = index;
      });
      this.selectedItems = this.onProductReorder();
      this.normalizeOrderIndices();
    },
    updateProductOrder(group) {
      group.products.forEach((product, index) => {
        product.orderIndex = index;
      });
      this.selectedItems = this.onProductReorder();
      this.normalizeOrderIndices();
    },
    setCropRatio(value) {
      if (value === "freeform") {
        this.selectedRatio = NaN;
      } else if (value === "original") {
        const imageData = this.$refs.cropper.getImageData()
        this.selectedRatio = imageData.naturalWidth / imageData.naturalHeight;
      } else {
        const [w, h] = value.split(":").map(Number);
        this.selectedRatio = w / h;
      }
      this.cropperKey++;
    },
    handleDropInModal(event) {
      this.handleDrop(event);
      this.isDragging = false;
    },
    handleDropAndReset(event) {
      this.handleDrop(event)
      this.isDragging = false
    },
    setindexcolor(index) {
      this.indexColor = index;
      this.colori = util.generateColor(index);
      this.selectcolor = false;
    },
    async removeImage() {
      this.imageData = "";
      this.imageDataBtn = "";
      this.remoteImagePath = "";
      this.isload = false;
      this.selectcolor = false;
    },
    generateObjectId() {
      const uid = `${localStorage.getItem('shopsUid')}`
      pos({
        method: 'get',
        url: '/api/v1.0/' + uid + '/objectId/generate',
      })
        .then((res) => {
          this.genObjectId = res.data.data.objectId
        })
        .catch((error) => {
          console.log(error)
        })
    },
    handleDrop(event) {
      event.preventDefault();
      const files = event.dataTransfer.files;
      if (!files || !files.length) return;

      const file = files[0];
      if (!file.type.startsWith("image/")) {
        alert("กรุณาเลือกรูปภาพเท่านั้น");
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        this.imageDataBtn = e.target.result;
        this.isUpload = false;
        this.cropperKey++;
        this.selectimg = true;
      };
      reader.readAsDataURL(file);
    },
    async savecolorimg() {
      this.loadingSaveimg = false;

      try {
        if (this.$refs.cropper && this.$refs.cropper.getCroppedCanvas) {
          const croppedImage = this.$refs.cropper.getCroppedCanvas().toDataURL();
          this.imageData = croppedImage;
          this.imageDataBtn = croppedImage;
          await this.getImageURL();
        } else {
          this.imageData = '';
          this.remoteImagePath = '';
          this.selectimg = false;
        }
      } catch (error) {
        console.error('เกิดข้อผิดพลาดขณะบันทึกรูปภาพ:', error);
        this.$toast && this.$toast.error('บันทึกรูปภาพไม่สำเร็จ');
      } finally {
        this.loadingSaveimg = true;
      }
    },
    async resizeImage(base64Str, maxWidth = 650, maxHeight = 500) {
      return new Promise((resolve) => {
        let img = new Image()
        img.src = base64Str
        img.onload = () => {
          let canvas = document.createElement('canvas')
          const MAX_WIDTH = maxWidth
          const MAX_HEIGHT = maxHeight
          let width = img.width
          let height = img.height

          if (width > height) {
            if (width > MAX_WIDTH) {
              height *= MAX_WIDTH / width
              width = MAX_WIDTH
            }
          } else {
            if (height > MAX_HEIGHT) {
              width *= MAX_HEIGHT / height
              height = MAX_HEIGHT
            }
          }
          canvas.width = width
          canvas.height = height
          let ctx = canvas.getContext('2d')
          ctx.drawImage(img, 0, 0, width, height)
          resolve(canvas.toDataURL())
        }
      })
    },
    async getImageURL() {
      const ref = this.$route.params.objectId || this.genObjectId;
      const getCroppedCanvas = this.$refs.cropper.getCroppedCanvas().toDataURL()
      const resizedImage = await this.resizeImage(getCroppedCanvas)
      let ext = await mime.getExtension(resizedImage)

      if (ext == null) {
        alert('Only Support File Type Is JPEG, PNG')
        this.isload = false
      } else {
        const oldImagePath = this.imagePath
        const imageName = util.generateFilename('.' + ext)
        const ownerUID = `${localStorage.getItem('uid')}`
        const directoryPath = 'resources/' + ownerUID + '/resources/products/' + ref + '/' + imageName

        let remoteImagePath = await this.onUploadProductImage(ref, resizedImage);

        this.remoteImagePath = remoteImagePath

        this.imgTmpPath = remoteImagePath
        this.imagePath = directoryPath
        this.selectimg = false
        this.loadingSaveimg = true
      }
    },
    async onUploadProductImage(ref, image) {

      let headers = { shopObjectId: util.sanitizeShopObjectId(this.shopObjectId) };
      let data = { ref, image };
      try {
        const res = await pos({
          method: 'POST',
          url: '/api/v3.0/upload/productimage',
          data,
          headers,
        });

        return res.data.data.publicUrl;
      } catch (error) {
        console.error('เกิดข้อผิดพลาดในการบันทึก:', error);
        return '';
      }
    },
    getModalImg(item, index) {
      if (item.remoteImagePath && item.remoteImagePath !== '') {
        this.imageData = item.remoteImagePath;
        this.imageDataBtn = item.remoteImagePath;
        this.remoteImagePath = item.remoteImagePath;
        this.$refs.cropper = item.remoteImagePath;
        this.$nextTick(() => {
          if (this.$refs.cropper) {
            this.$refs.cropper.replace(item.remoteImagePath);
          }
        });
      } else {
        this.remoteImagePath = '';
        this.imageData = '';
        this.imageDataBtn = '';
      }
      this.genObjectId = item.objectId
      this.indexColor = item.indexColor
      this.selectedIndex = index;
      this.selectimg = true
    },
    uploadImage(e) {
      const file = e.target.files[0]

      if (typeof FileReader === 'function') {
        this.dialog = true

        const reader = new FileReader()
        reader.onload = (event) => {
          this.imageDataBtn = event.target.result
          this.$refs.cropper = this.imageData
          this.isUpload = false
          this.isload = true
        }
        reader.readAsDataURL(file)
      } else {
        alert('Sorry, FileReader API not supported')
      }
    },
    cancel() {
      this.selectimg = false;
    },
    triggerFileInput() {
      this.$refs.input_img.click();
    },
    handleFileSelect(event) {
      const file = event.target.files[0];
      if (!file) return;

      if (!file.type.startsWith('image/')) {
        alert('กรุณาเลือกรูปภาพ');
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        this.imageDataBtn = e.target.result;
        this.isUpload = false;
        this.cropperKey++;
        this.selectimg = true;
      };
      reader.readAsDataURL(file);
    },
    setSearch(searchBy, keyword) {
      this.keyword = keyword;
      this.searchBy = searchBy;
      this.getProduct();
    },
    carryRowIds(src = {}) {
      const out = {};
      if (src.objectId) out.objectId = src.objectId;
      if (src.id) out.id = src.id;
      return out;
    },
    toggleItem(product) {
      const skuId = this.getSKU(product).objectId;

      const idx = this.selectedItems.findIndex(p =>
        (p.productSKU?.objectId || p.productSKUObjectId || p.objectId) === skuId
      );

      if (idx !== -1) {
        this.selectedItems.splice(idx, 1);
      } else {
        this.selectedItems.push(this.buildSelectedItem(product));
      }

      this.selectedProductsByCategory = this.groupedProductsByInSET(true);
      this.additionalItems = this.flattenedAdditionalProducts;
    },
    toggleSelectAll() {
      const skuIdOf = (x) => x?.productSKU?.objectId || x?.productSKUObjectId || x?.objectId;
      const allIds = this.products.map(skuIdOf).filter(Boolean);
      const selectedIds = new Set(this.selectedItems.map(skuIdOf).filter(Boolean));
      const allSelected = allIds.length > 0 && allIds.every(id => selectedIds.has(id));

      if (allSelected) {
        const ids = new Set(allIds);
        this.selectedItems = this.selectedItems.filter(it => !ids.has(skuIdOf(it)));
      } else {
        this.products.forEach(product => {
          const id = skuIdOf(product);
          if (!selectedIds.has(id)) {
            this.selectedItems.push(this.buildSelectedItem(product));
          }
        });
      }

      this.selectedProductsByCategory = this.groupedProductsByInSET(true);
      this.additionalItems = this.flattenedAdditionalProducts;
    },
    buildSelectedItem(product, inSETFlag) {
      const sku = this.getSKU(product);
      return {
        ...product,
        productSKU: sku,
        productSKUObjectId: sku.objectId,
        inSET: typeof product.inSET === 'boolean'
          ? product.inSET
          : (inSETFlag ?? !this.isAddingExtraProduct),
        orderIndex: Number.isFinite(product.orderIndex) ? product.orderIndex : this.selectedItems.length,
        maximumStack: product.maximumStack ?? 0,
        isEnabled: typeof product.isEnabled === 'boolean' ? product.isEnabled : true,
      };
    },
    saveSelection() {
      console.log("Selected:", this.selectedItems);
    },
    areAllSelectedByCategory(category) {
      const skuIdOf = (x) => x?.productSKU?.objectId || x?.productSKUObjectId || x?.objectId;
      const products = this.categorizedProducts[category] || [];
      const selectedSkuIds = new Set(this.selectedItems.map(skuIdOf).filter(Boolean));
      return products.length > 0 && products.every(p => selectedSkuIds.has(skuIdOf(p)));
    },
    toggleSelectAllByCategory(category) {
      const skuIdOf = (x) => x?.productSKU?.objectId || x?.productSKUObjectId || x?.objectId;
      const categoryItems = (this.filteredCategorizedProducts[category] || []).slice();
      const selectedSkuIds = new Set(this.selectedItems.map(skuIdOf).filter(Boolean));
      const allSelected = categoryItems.every(p => selectedSkuIds.has(skuIdOf(p)));

      if (allSelected) {
        const ids = new Set(categoryItems.map(skuIdOf));
        this.selectedItems = this.selectedItems.filter(it => !ids.has(skuIdOf(it)));
      } else {
        categoryItems.forEach(product => {
          const id = skuIdOf(product);
          if (!selectedSkuIds.has(id)) {
            this.selectedItems.push(this.buildSelectedItem(product));
          }
        });
      }

      this.selectedProductsByCategory = this.groupedProductsByInSET(true);
      this.additionalItems = this.flattenedAdditionalProducts;
    },
    getProduct(page = this.$route.query.page || 1) {
      this.searchLoadingButton = false;
      this.loadingButton = false;
      const shopObjectId = this.shopObjectId;
      const headers = { shopObjectId: util.sanitizeShopObjectId(shopObjectId) };

      let sortOrder = "";
      if (this.sortdata == "sortByNumMin") {
        sortOrder = "asc";
      } else if (
        this.sortdata == "sortByNumMax" ||
        this.sortdata == "updated_at"
      ) {
        sortOrder = "desc";
      } else {
        sortOrder = "asc";
      }

      let params = {
        shopObjectId: shopObjectId,
        page: page,
        sortAttr: this.sortAttr,
        sortOrder: sortOrder,
        limit: this.meta_data.limit,
      };
      if (this.searchCategory !== null) {
        params["categoryObjectId"] = this.searchCategory.objectId
      }
      pos({
        url: "/api/v3.0/productsku/quicklist",
        params: params,
        headers: headers,
        method: "GET",
      }).then((res) => {

        this.products = res.data.data.map((item) => ({
          ...item,
          edited: false,
        }));

        if (res.data.paginate.items == undefined) {
          this.countProduct = 0;
          this.meta_data.items = 0;
        } else {
          this.countProduct = res.data.paginate.items;
          this.meta_data.items = res.data.paginate.items;
        }
        this.meta_data.last_page = res.data.paginate.pageCount;
        this.meta_data.current_page = res.data.paginate.currentPage;
        this.meta_data.itemCount = res.data.paginate.itemCount;
        this.meta_data.limit = res.data.paginate.perPage;
        this.searchLoadingButton = true;
        this.loadingButton = true;
      });
    },
    async addPackage() {
      if (this.loading) return;
      this.loading = true;

      try {
        const name = (this.packageName || '').trim();
        if (!name) {
          throw new Error('Package name is required');
        }
        if (!this.selectedItems.length) {
          throw new Error('No items selected');
        }

        let isFormValid = true;
        const mainPrice = Number(this.packagePrices?.[0]?.price ?? 0);
        this.packagePrices = this.packagePrices.map((p, i) => {
          const priceNum = Number(p.price);
          const hasError =
            !name || isNaN(priceNum) || priceNum < 0 || (i > 0 && priceNum >= mainPrice);
          if (hasError) isFormValid = false;
          return { ...p, hasError };
        });

        if (!isFormValid || mainPrice <= 0) {
          throw new Error('Invalid prices');
        }
        this.normalizeOrderIndices();

        const data = {
          name,
          description: this.packageDescription || '',
          remoteImagePath: this.remoteImagePath || '',
          enabled: this.enabled,
          indexColor: this.indexColor,
          ProductSKUPackage: this.onProductReorder(),
          vatType: this.vatType,
          productPLU: this.packagePrices.map((p, i) => ({
            name: this.getFullPLUName(i, p),                // ชื่อเต็ม
            shortName: i === 0 ? '' : (p.shortName || ''),  // ชื่อย่อย
            price: Number(p.price) || 0,
            PLUCode: p.PLUCode || this.util.generateBarcode(),
            isProductPLU1: i === 0,
            orderIndex: i,
          })),
        };

        const params = { shopObjectId: this.util.sanitizeShopObjectId(this.shopObjectId) };
        const headers = { shopObjectId: this.util.sanitizeShopObjectId(this.shopObjectId) };

        await packageservice.post(`/api/v3.0/${this.uid}/productpackage`, data, { params, headers });

        this.$toast.success(this.$t('addPackageSuccess'), { position: 'top-right', timeout: 2000 })
        this.$router.push({ name: 'ProductPackage' });
      } catch (err) {
        const parsed = util.parseApiError(err);
        console.error('addPackage failed:', err);
        if (parsed.fieldErrors) {
          if (parsed.fieldErrors.price || parsed.fieldErrors['productPLU.0.price']) {
            if (this.packagePrices?.[0]) this.packagePrices[0].hasError = true;
          }
          Object.keys(parsed.fieldErrors).forEach((k) => {
            const m = k.match(/^productPLU\.(\d+)\.price$/);
            if (m) {
              const idx = Number(m[1]);
              if (this.packagePrices?.[idx]) this.packagePrices[idx].hasError = true;
            }
          });
        }

        this.$toast.error(parsed.message || this.$t('addPackageFailed'), { position: 'top-right', timeout: 3000 });
      } finally {
        this.loading = false;
      }
    },

    getCategory() {
      const uid = `${localStorage.getItem("shopsUid")}`;
      const shopObjectId = this.shopObjectId;
      let params = {
        page: 1,
        limit: 1000,
      };
      const headers = {
        shopObjectId: util.sanitizeShopObjectId(shopObjectId),
      };
      pos
        .get("/api/v1.0/shop/" + uid + "/Category/data/" + shopObjectId, {
          params, headers
        })
        .then((res) => {
          this.dataCategory = res.data.data;
          let data = this.dataCategory;
          for (let i = 0; i < data.length; i++) {
            if (data[i].id == "0") {
              this.category = {
                id: data[i].id,
                name: data[i].name,
                objectId: data[i].objectId,
              };
            }
          }
          const packageId = this.$route.params.objectId;
          if (packageId) {
            this.loadPackage(packageId);
          } else {
            this.generateObjectId();
          }
        });

    },
    async updatePackage() {
      if (this.loading) return;
      this.loading = true;

      try {
        const objectId = this.$route.params.objectId;
        if (!objectId) throw new Error('Missing package objectId');

        const name = (this.packageName || '').trim();
        if (!name) {
          throw new Error('Package name is required');
        }
        if (!this.selectedItems.length) {
          throw new Error('No items selected');
        }
        
        const current = this.packagePrices || [];
        const original = this.originalPackagePrices || [];
        
        const currentExcludeZero = current.filter((_, i) => i > 0);
        const originalExcludeZero = original.filter((_, i) => i > 0);

        // 1. หารายการที่ถูกลบ (ต้องอยู่ใน originalExcludeZero และไม่มีใน currentExcludeZero)
        const toDelete = originalExcludeZero.filter(o => 
              !currentExcludeZero.some(c => c.objectId === o.objectId)
        );

        // 2. หารายการที่ต้องเพิ่มหรือแก้ไข (มีใน currentExcludeZero)
        const toSave = currentExcludeZero.filter(c => {
          if (c.isProductPLU1 === true) return false;
          const orig = originalExcludeZero.find(o => o.objectId === c.objectId);
          
          return !orig || JSON.stringify(orig) !== JSON.stringify(c);
        });

        // 3. Process ลบ
        for (const item of toDelete) {          
          await this.callDeletePLU(item);
        }

        // 4. Process เพิ่มหรือแก้ไข
        for (const item of toSave) {
          await this.callSavePLU(item);
        }
        
        // 4. เมื่อจัดการ PLU เสร็จแล้ว ค่อยยิง Patch Package หลัก
        await this.patchProductPackage();

        this.$toast.success(this.$t('updatePackageSuccess'));
        this.originalPackageName = this.packageName;
        this.originalPackageDescription = this.packageDescription;
        this.originalImagePath = this.remoteImagePath;
        this.originalIndexColor = this.indexColor;
        this.originalEnabled = this.enabled;
        this.originalVatType = this.vatType;
        this.loadPackage(objectId);
        this.originalSelectedItems = JSON.parse(JSON.stringify(this.selectedItems));
        this.originalPackagePrices = JSON.parse(JSON.stringify(this.packagePrices));
      } catch (err) {
        this.$toast.error('Process failed: ' + err.message);
      } finally {
        this.loading = false;
      }
    },

    // Helper methods
    async callDeletePLU(item) {
      const uid = localStorage.getItem("shopsUid");
      await pos({
        method: "post",
        url: `/api/v1.0/${uid}/ProductPLU/softdelete`,
        params: { plan: this.users.currentPlan },
        headers: { shopObjectId: this.util.sanitizeShopObjectId(this.shopObjectId) },
        data: { shopObjectId: this.shopObjectId, objectId: item.objectId }
      });
    },

    async callSavePLU(item) {

      const uid = localStorage.getItem("shopsUid");
      // จัดเตรียม data ให้ตรงกับที่ saveProductPLU ของคุณต้องการ
      // 1. เตรียมข้อมูลพื้นฐาน (รวมทุกฟิลด์ที่ทั้ง save และ edit ต้องการ)
      const data = {
        // // ถ้ามี objectId/id ให้ใส่ไป (เพื่อแยกกรณี Add หรือ Edit)
        // ...(item.id && { id: item.id }),
        objectId: item.objectId ,
        PLUCode: item.PLUCode || this.util.generateBarcode(),
        SKURatio: 1,
        enabled: true,
        indexColor: this.packageData.indexColor,
        mixedPrice: false,
        name: this.packageName + ' ('+ item.shortName + ')',
        price: Number(item.price ||  0),
        
        // โครงสร้าง ProductSKU
        productSKU: {
          SKUName: this.packageName || '',
          SKUPrice: Number(this.packageData.productSKU?.SKUPrice || 0),
          id: this.packageData.productSKU?.id,
          objectId: this.packageData.productSKU?.objectId,
        },
        productSKUId: this.packageData.productSKU?.id ,
        
        // ข้อมูล Shop และ Unit
        shop: this.packageData.shop,
        shopId: this.packageData.shop?.id,
        unit: this.packageData.unit,
        unitId: this.packageData.unit?.id,
        
        // ข้อมูลเพิ่มเติม
        remoteImagePath: this.packageData.remoteImagePath || '',
        isMenu : true
      };
      
      await pos({
        method: "post",
        url: `/api/v1.0/${uid}/productplu/add`,
        params: { shopObjectId: this.shopObjectId, plan: this.users.currentPlan },
        data: data
      });
    },

    async patchProductPackage() {
      // 1. จัดเตรียม Data สำหรับ PLU ที่ต้องการอัปเดต (ตามโครงสร้างใหม่ที่คุณต้องการ)
      const primaryPLU = this.packagePrices && this.packagePrices.length > 0 ? this.packagePrices[0] : null;

      const objectId = this.$route.params.objectId;
      const orderedItems = this.onProductReorder();
      this.normalizeOrderIndices();
      const payload = {
        name: (this.packageName || '').trim(),
        description: this.packageDescription || '',
        remoteImagePath: this.remoteImagePath || '',
        indexColor: this.indexColor,
        enabled: this.enabled,
        vatType: this.vatType,
        ProductSKUPackageReplace: true,
        price : Number(primaryPLU.price),
        ProductSKUPackage: (orderedItems || []).map((it, idx) => ({
          id: it.id || undefined,
          objectId: it.objectId || undefined,
          orderIndex: Number.isFinite(+it.orderIndex) ? +it.orderIndex : idx,
          inSET: typeof it.inSET === 'boolean' ? it.inSET : true,
          maximumStack: Number(it.maximumStack || 0),
          isEnabled: typeof it.isEnabled === 'boolean' ? it.isEnabled : true,
          productSKUObjectId: it.productSKU?.objectId || it.productSKUObjectId || it.objectId,
          productSKU: {
            id: it.productSKU?.id || undefined,
            objectId: it.productSKU?.objectId || it.productSKUObjectId || it.objectId,
            SKUName: it.productSKU?.SKUName || it.productSKU?.name || it.name || '',
            SKUPrice: Number(it.productSKU?.SKUPrice ?? it.SKUPrice ?? 0),
            remoteImagePath: it.productSKU?.remoteImagePath || '',
            indexColor: Number(it.productSKU?.indexColor ?? 0),
          },
          productPackageObjectId: objectId,
        })),
        productPLU: {
          PLUCode  : primaryPLU.PLUCode,
          price: Number(primaryPLU.price) || 0,
        }
      };

      // 2. จัดเตรียม Params และ Headers
      const params = {
        shopObjectId: this.util.sanitizeShopObjectId(this.shopObjectId),
        objectId: this.$route.params.objectId
      };

      const headers = {
        shopObjectId: this.util.sanitizeShopObjectId(this.shopObjectId),
        uid: this.uid
      };

      // 3. ยิง Request ไปยัง Endpoint หลัก
      try {
        await packageservice.patch(
          `/api/v3.0/${this.uid}/productpackage`, 
          payload, 
          { headers, params }
        );
      } catch (error) {
        console.error('Failed to patch product package:', error);
        throw error; // ส่งต่อ error ให้ฟังก์ชันหลักจัดการ
      }
    },
    getProductImageStyle(product) {
      const imagePath = product.remoteImagePath || (product.ProductSKU && product.ProductSKU.remoteImagePath) || '';
      return {
        backgroundColor: '#dddddd',
        color: '#4B5F71',
        aspectRatio: '1/1',
        borderRadius: '7px',
        fontSize: 'x-large',
        backgroundImage: `url(${imagePath})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      };
    },
    getProductPrice(product) {
      return product.productSKU && product.productSKU.SKUPrice
        ? product.ProductSKU.SKUPrice
        : product.ProductSKU && product.ProductSKU.SKUPrice
          ? product.ProductSKU.SKUPrice
          : 0;
    },
    onProductReorder() {
      const updatedInSetItems = [];
      let index = 0;

      this.selectedProductsByCategory.forEach(group => {
        group.products.forEach(product => {
          const sku = this.getSKU(product);
          updatedInSetItems.push({
            productSKU: this.minifySKU(sku),
            productSKUObjectId: sku.objectId,
            inSET: true,
            orderIndex: index++,
            maximumStack: Number(product.maximumStack || 0),
            isEnabled: typeof product.isEnabled === 'boolean' ? product.isEnabled : true,
          });
        });
      });

      const extraProducts = this.additionalItems.map((product, i) => {
        const sku = this.getSKU(product);
        return {
          ...this.carryRowIds(product),
          productSKU: this.minifySKU(sku),
          productSKUObjectId: sku.objectId,
          inSET: false,
          orderIndex: index + i,
          maximumStack: Number(product.maximumStack || 0),
          isEnabled: typeof product.isEnabled === 'boolean' ? product.isEnabled : true,
        };
      });

      return [...updatedInSetItems, ...extraProducts];
    }
  },
};
</script>

<style scoped>
.is-off {
  background-color: rgba(255, 193, 7, 0.10);
  border-color: rgba(255, 193, 7, 0.35);
}

.is-off .fw-bold {
  color: #6c757d;
}

.is-off img {
  filter: grayscale(45%);
}

.action-right {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.list-group-item .close-btn {
  line-height: 1;
  padding: 0.1rem 0.1rem;
}

@media (max-width: 576px) {
  .action-right {
    gap: 4px;
  }
}

.opacity-50 .fw-bold {
  text-decoration: line-through;
}

.is-invalid {
  border: 1px solid red;
}

.img-inputbox {
  width: 200px;
  aspect-ratio: 4/3;
  border-radius: 4px;
  background-color: #eeeeee;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  overflow: hidden;
}

.custom-checkbox-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}

.custom-checkbox-input {
  width: 16px;
  height: 16px;
  margin-right: 6px;
  cursor: pointer;
}

@media (max-height: 800px) {
  .category-scroll-box {
    max-height: 50vh;
  }
}

.drop-area {
  border: 2px dashed #ccc;
  border-radius: 10px;
  padding: 10px;
  transition: border 0.3s ease;
}

.drop-area.dragover {
  border-color: #29b289;
  background-color: #f9f9f9;
}

.display.dragover {
  border: 2px dashed #29b289;
  background-color: #f3fdfa;
  transition: 0.3s ease;
}

.dragover {
  border: 2px dashed #29b289;
  background-color: #e6f8f0;
  border-radius: 5px;
  transition: all 0.2s ease-in-out;
}

.custom-file-label i {
  font-size: 16px;
}

.color-picker-btn {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  padding: 0;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: box-shadow 0.2s ease;
}

.color-picker-btn.active {
  box-shadow: 0 0 0 2px white, 0 0 0 4px #29b289;
}

.selected-icon {
  font-size: 14px;
  color: white;
}

.color-picker-col {
  box-sizing: border-box;
}

.color-picker-btn.active {
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.2);
  position: relative;
}

.file-upload-container {
  display: flex;
  align-items: center;
  justify-content: left;
}

.file-upload-container input[type="file"] {
  display: none;
}

.custom-file-label {
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 2px;
  transition: background-color 0.3s;
}

.custom-file-label i {
  font-size: 16px;
}

.color-picker-col {
  width: 31px;
  height: 31px;
 display: contents;
  justify-content: center;
  align-items: center;
  padding: 1px;
}

.color-picker-btn {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: none;
  box-shadow: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
}

.color-picker-btn.active {
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.2);
  position: relative;
}

.selected-icon {
  color: white;
  font-size: 14px;
}

.img-inputbox.dragover {
  border: 2px dashed #29b289;
  background-color: #f3fdfa;
}

.drop-area.dragover {
  border: 2px dashed #29b289;
  background-color: #f3fdfa;
  transition: background-color 0.3s;
}

.badge-tomato {
  color: #fff;
  background-color: tomato;
}

.badge-lightseagreen {
  color: #fff;
  background-color: lightseagreen;
}

.square-box {
  position: relative;
  width: 20%;
  overflow: hidden;
  border-radius: 3px;
}

.square-box:before {
  content: '';
  display: block;
  padding-top: 100%;
}

.phone-mocking {
  padding: 10px;
  border-radius: 10px;
  width: 250px;
  height: 500px;
  background-color: none;
  margin-top: 20px;
  overflow-y: scroll;
}

.phone-mocking::-webkit-scrollbar {
  display: none;
}

.container-phone {
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url('/img/iphone.webp');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  width: 300px;
  height: 600px;
  overflow-y: scroll;
}

.container-phone::-webkit-scrollbar {
  display: none;
}

.toggles {
  position: relative;
  display: inline-block;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 8px;
  border-radius: 5px;
  width: 50px;
  height: 30px;
  color: #ffffff;
  font-size: small;
  opacity: 0.8;
}

.callStaff {
  display: inline-block;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 8px;
  border-radius: 5px;
  width: 50px;
  height: 30px;
  background-color: #29B46B;
  color: #ffffff;
  font-size: small;
}

.banner {
  border-radius: 10px;
  height: 100px;
}

.recommend-container {
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
  display: inline-flex;
}

.recommend-container::-webkit-scrollbar {
  display: none;
}

.image-input {
  background-color: rgb(230, 230, 230);
  width: 100%;
  height: 200px;
  border-radius: 10px;
}

.select-item-card {
  height: 300px;
  overflow-x: scroll;
}

.category-btn-active {
  font-size: x-small;
  background-color: #29B46B;
  width: fit-content;
  padding: 1cap;
  color: white;
  border-radius: 5px;
  padding-left: 2cap;
  padding-right: 2cap;
  margin: 1cap;
  font-size: x-small;
  white-space: nowrap;
}

.category-btn {
  font-size: x-small;
  background-color: #eeeeee;
  white-space: nowrap;
  padding: 1cap;
  color: rgb(109, 109, 109);
  border-radius: 5px;
  padding-left: 2cap;
  padding-right: 2cap;
  margin: 1cap;
}

.theme-color {
  width: 40px;
  aspect-ratio: 1/1;
  border: none;
  border-radius: 7px;
  margin-right: 1cap;
  margin-bottom: 1cap;

}

.footer-home {
  position: absolute;
  top: 520px;
  left: 50%;
  transform: translateX(-50%);
  width: 240px;
  height: 40px;
  color: white;
  padding: 2cap;
  border-radius: 50px;

}

.footer-modal {
  text-align: center;
  width: 220px;
  height: 40px;
  color: white;
  padding: 2cap;
  border-radius: 50px;
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
}

.policy-box {
  position: absolute;
  top: 26px;
  left: 50%;
  transform: translateX(-50%);
  width: 253px;
  height: 548px;
  border-radius: 36px;

}

.policy-modal {
  width: 95%;
  height: 250px;
  background-color: #ffffff;
  border-radius: 35px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 5px;

}

.backdrop-pilocy {
  width: 100%;
  height: 100%;
  background-color: #191919;
  border-radius: 35px;
  opacity: 0.7;
}

.display-option {
  width: 100px;
  aspect-ratio: 1/1;
  background-color: #f9f9f9;
  border: 2px solid #eeeeee;
  margin-right: 1cap;
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  border-radius: 8px;
}

.display-option-selected {
  width: 100px;
  aspect-ratio: 1/1;
  background-color: #3abc98;
  border: 2px solid #eeeeee;
  margin-right: 1cap;
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  border-radius: 8px;
  color: white;
}

.display-option-selected:hover {
  color: white;
}

.qr-type-box {
  width: 100%;
  border-radius: 8px;
  border: 2px solid #eeeeee;
  background-color: #f9f9f9;
  display: flex;
  padding: 2cap
}

.badge-new {
  background-color: red;
  color: white;
  font-size: 14px;
  padding: 1px 6px;
  border-radius: 10px;
  font-weight: bold;
}

.static-sticker-btn {
  background-color: #ffffff;
  border: 2px solid #eeeeee;
  margin-right: 1cap;
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  border-radius: 8px;
}

.static-qr-contact-line {
  background-color: #00b900;
  border-radius: 5px;
  color: #fff;
  font-weight: bold;
  width: fit-content;
  justify-self: left;
}

.line-btn-q:hover {
  color: #fff;
}

.floating-save-btn {
  position: fixed;
  bottom: 25px;
  right: 100px;
  z-index: 1999;
  padding: 12px 54px;
  font-size: 16px;
  border-radius: 8px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  background: #3abc98;
  color: white;
  border: none;
  cursor: pointer;
}

.floating-save-btn-dirty {
  position: fixed;
  bottom: 25px;
  right: 100px;
  z-index: 1999;
  padding: 12px 54px;
  font-size: 16px;
  border-radius: 8px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  background: #3abc98;
  color: white;
  border: none;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
  animation: pulseEffect 1.5s infinite;
}

@media screen and (max-width: 768px) {
  .floating-save-btn {
    right: 50%;
    transform: translateX(50%);
  }

  .floating-save-btn-dirty {
    right: 50%;
    transform: translateX(50%);
  }
}

@keyframes pulseEffect {
  0% {
    box-shadow: 0 0 0 0 rgba(58, 188, 152, 0.5);
  }

  70% {
    box-shadow: 0 0 0 15px rgba(58, 188, 152, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(58, 188, 152, 0);
  }
}

.grey-box {
  background-color: #f9f9f9;
  border: 1px solid #eeeeee;
  border-radius: 8px;
}

.truncate-2-lines {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: xx-small;
}
</style>

<style src="../../../assets/styles/multiselect.css"></style>
